import { Component, OnInit } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { HelpersService } from '../../../../services/helpers.service';
import { CyclistService } from '../../../../services/cyclist.service';
import { AuthenticationService } from '../../../../services/authentication.service';
import { BroadcastService } from '../../../../services/broadcast.service';
import { MessageService } from 'primeng/api';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeMyPasswordComponent } from '../../../modals/change-my-password/change-my-password.component';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../../../../app.config';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-myprofile',
  templateUrl: './myprofile.component.html',
  styleUrls: ['./myprofile.component.scss'],
  providers: [MessageService],
})
export class MyprofileComponent implements OnInit {
  public UserForm: FormGroup;
  public genders: any = [];
  public busy: boolean = false;
  public user: any = {};
  public userId: any;
  public languages: any = this.appConfig.getLanguages();
  public units: any = this.appConfig.getUnits();
  public countryData: any = {};

  public tfaBusy: boolean = false;
  public TFAEnabled: boolean = true;

  constructor(
    private appConfig: AppConfig,
    private fb: FormBuilder,
    private helpersService: HelpersService,
    private cyclistService: CyclistService,
    public authService: AuthenticationService,
    private messageService: MessageService,
    private broadcastService: BroadcastService,
    public modal: NgbModal,
    public router: Router,
    private translate: TranslateService,
  ) {
    this.countryData = this.helpersService.getCountryData();
    this.userId = this.helpersService.getProfileData().ID;
    this.languages = this.languages.filter((x) => {
      return x.type === this.appConfig.getPartnerType();
    });
    if (this.languages.length === 1) {
      this.languages.unshift({ label: 'Select a Language', value: '' });
    }
    console.log(this.languages);
    this.getUpdatedUser();
    this.languageChanged();
  }

  getUpdatedUser() {
    this.busy = true;
    this.cyclistService.getCyclistById(this.userId).subscribe((user) => {
      console.log(user);
      this.busy = false;
      this.user = user;

      this.TFAEnabled = user.TwoFactorEnabled;

      this.setupValidation();
    });
  }

  ngOnInit() {}

  setupValidation() {
    this.UserForm = this.fb.group({
      Name: new FormControl(this.user.Name, Validators.required),
      Surname: new FormControl(this.user.Surname, Validators.required),
      Email: new FormControl(this.user.Email, [
        Validators.required,
        Validators.email,
      ]),
      PhoneNumber: new FormControl(
        this.user.PhoneNumber,
        Validators.nullValidator,
      ),
      DateOfBirth: new FormControl(
        this.user.DateOfBirth == null ? null : moment(this.user.DateOfBirth).toDate() || null,
        Validators.nullValidator,
      ),
      GenderID: new FormControl(this.user.GenderID, Validators.nullValidator),
      Locale: new FormControl(this.user.Locale, Validators.nullValidator),
      UnitsOfMeasureID: new FormControl(
        this.user.UnitsOfMeasureID,
        Validators.nullValidator,
      ),
    });
  }

  languageChanged() {
    //this.appConfig.setLocale(this.UserForm.get('Language').value);
    //this.translate.setDefaultLang(this.UserForm.get('Language').value);
    this.genders = [
      { label: this.translate.instant('general.male'), value: 1 },
      { label: this.translate.instant('general.female'), value: 2 },
    ];
  }

  saveUser(user) {
    this.busy = true;
    let update = { ...this.user, ...user };
    this.cyclistService.saveCyclist(update).subscribe((updatedUser) => {
      this.busy = false;
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant(
          'general.my_profile_form.message_profile_updated',
        ),
      });
      this.broadcastService.sendMessage({ profile: updatedUser });

      //Set the new language
      this.appConfig.setLocale(this.UserForm.get('Locale').value);
      this.translate.setDefaultLang(
        (this.appConfig.getPartnerType() === 'bicycle'
          ? ''
          : this.appConfig.getPartnerType() + '/') +
          this.UserForm.get('Locale').value,
      );
      this.languageChanged();
    });
  }

  getInitial() {
    var name =
      this.UserForm.controls['Name'].value +
      ' ' +
      this.UserForm.controls['Surname'].value;
    if (name) {
      var names = name.trim().split(' ');
      if (names.length >= 2) {
        return names
          .map((n) => {
            return n[0] !== undefined ? n[0].toUpperCase() : n[0];
          })
          .join('');
      } else {
        return name.substring(0, 2) !== undefined
          ? name.substring(0, 2).toUpperCase()
          : name.substring(0, 2);
      }
    } else {
      return 'NA';
    }
  }

  updatePhoto(event) {
    this.busy = true;
    let uploadFile = event.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(uploadFile);
    reader.onload = (file: any) => {
      let data = {
        ImageData: file.target.result.split(',')[1],
      };
      this.cyclistService.saveImage(data).subscribe((photo) => {
        this.busy = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'general.my_profile_form.message_profile_photo_updated',
          ),
        });
        this.cyclistService.getCyclistById(this.userId).subscribe((user) => {
          this.user = user;
          this.broadcastService.sendMessage({ profile: user });
        });
      });
    };
  }

  changePassword() {
    const modalRef = this.modal.open(ChangeMyPasswordComponent);
    modalRef.componentInstance.user = this.user;
    modalRef.result.then(
      (result) => {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'general.my_profile_form.message_password_changed',
          ),
        });
      },
      (onrejected) => {},
    );
  }

  disable2FA() {
    this.tfaBusy = true;

    this.authService.disableUser2FA().subscribe((result) => {
      this.tfaBusy = false;
      this.TFAEnabled = false;
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant(
          'general.my_profile_form.message_tfa_disabled',
        ),
      });
    });
  }

  enable2FA() {
    this.router.navigateByUrl('/store/myprofile-tfasetup');
  }
}
